import { Cliente } from "../objeto_cliente";
import { convertirFechaFirebase, parsearContenido } from "../utiles_objetos";

export class ChatUsuario{
    constructor({
        phone_number = 0,
        company_name = "",
        name = "",
        last_message_timestamp = 0,
        session_expires_at = 0,

        label,
        unread_messages_count,
        last_message_preview,
        last_message_is_from_user,

        source_url,
        source_id,
        source_type,
        ctwa_clid,

        clienteInfo = new Cliente(),

        archivo = false,

    } = {} ){
        this.phone_number = phone_number;
        this.company_name = company_name;
        this.name = name;
        this.last_message_timestamp = last_message_timestamp;
        this.session_expires_at = session_expires_at;

        this.label = label;
        this.unread_messages_count = unread_messages_count;
        this.last_message_preview = last_message_preview;
        this.last_message_is_from_user = last_message_is_from_user;
        this.source_url = source_url;
        this.source_id = source_id;
        this.source_type = source_type;
        this.ctwa_clid = ctwa_clid;
        
        this.clienteInfo = clienteInfo;
        this.archivo = archivo;
    }

    static fromJson (json){

        console.log("chat usuario json fromjnson",json);

        const fechasession_expires_at = convertirFechaFirebase(json['last_message_timestamp']);
        const fechsession_expires_at = convertirFechaFirebase(json['session_expires_at']);


        return new ChatUsuario({
            phone_number: json['phone_number'] || 0,
            company_name: json['company_name'] || "",
            name: json['name'] || "",
            last_message_timestamp: fechasession_expires_at,
            session_expires_at: fechsession_expires_at,

            label: json['label'] || '',
            unread_messages_count: json['unread_messages_count'] || 0,
            last_message_preview: json['last_message_preview'] || 'Mensaje no reconocido',
            last_message_is_from_user: json['last_message_is_from_user'] || true,
            source_url: json['source_url'] || '',
            source_id: json['source_id'] || '',
            source_type: json['source_type'] || '',
            ctwa_clid: json['ctwa_clid'] || '',

            clienteInfo: json['clienteInfo'] 
                ? Cliente.fromJson(json['clienteInfo']) // Asumimos que Cliente también tiene un método estático
                : new Cliente(),

            archivo: json['archivo'] ?? false,
        })

    }

}

export class MensajeUsuario{
    constructor({
        id = "",
        message_type = "",
        content = {},
        status_history = [],
        latest_status = 'sent_baseData',
        is_from_user = false,
        timestamp = 0,
        nameuser = "",

        latest_error = "",

    } = {}){
        this.id = id;
        this.message_type = message_type;
        this.content = content;
        this.status_history = status_history;
        this.latest_status = latest_status;
        this.is_from_user = is_from_user;
        this.timestamp = timestamp;
        this.nameuser = nameuser;

        this.latest_error = latest_error;
    }

    static fromJson (json){

        const fecha_timestamp = convertirFechaFirebase(json['timestamp']);
        const history = json['status_history'] || [];
        let latestStatus = 'sent_baseData'; 
        let latest_error = null;
        if (history.length > 0) {
            latestStatus = history[history.length - 1].status;
            latest_error = history[history.length - 1].error;
        }

        console.log("ultimo status",latestStatus,latest_error);

        return new MensajeUsuario({
            id : json['id'] || '',
            message_type : json['message_type'] || '',
            content : parsearContenido(json['content']),
            status_history :  history,
            latest_status: latestStatus,
            is_from_user : json['is_from_user'] ?? true,
            timestamp: fecha_timestamp,
            nameuser: json['nameuser'] || '',
            latest_error: latest_error,
        });
    }
}